import React, { useState, useContext } from "react";
import { Row, Col, Form, Card, Button, Table } from "react-bootstrap";
import InputText from "../Elements/InputText.jsx";
import InputPassword from "../Elements/InputPassword.jsx";
import InputSelect from "../Elements/InputSelect.jsx";
import { Store } from "react-notifications-component";
import { Divider } from "rsuite";
import axios from "axios";
import PermissionContext from "../../Store/permission-context";

const ChangePassword = () => {
  const [Username, setUsername] = useState("");
  const [OldGateway, setOldGateway] = useState("");
  const [NewGateway, setNewGateway] = useState("");
  const [ReNewGateway, setReNewGateway] = useState("");
  const [AxiosError, setAxiosError] = useState("");
  var CryptoJS = require("crypto-js");
  let ConnectionCount = 0;
  const PCtx = useContext(PermissionContext);
  const changeThePassword = async (e) => {
    e.preventDefault();

    if (NewGateway === ReNewGateway) {
      let logindetails = { Username: Username, Gateway: OldGateway };
      let CheckLogin = await PCtx.connectAxios("getaccess.php", logindetails);
      if (CheckLogin) {
        if (!CheckLogin.Scrambled.includes("Disallowed")) {
          let Scramb = CheckLogin.Scrambled;
          let Scrambled = Scramb.replace(/\s/g, "");
          var bytes = CryptoJS.AES.decrypt(Scrambled, "143tonybridget");
          var Allowance = bytes.toString(CryptoJS.enc.Utf8);
          if (OldGateway === Allowance) {
            var TheEncrypted = CryptoJS.AES.encrypt(
              NewGateway,
              "143tonybridget"
            ).toString();
            let newlogindetails = { Username: Username, Gateway: TheEncrypted };
            let UpdatePassword = await PCtx.connectAxios(
              "savenewpass.php",
              newlogindetails
            );
            if (!UpdatePassword.includes("Error")) {
              PCtx.displayAlert(
                "SUCCESS",
                "Password changed successfully!",
                "success"
              );
            } else {
              PCtx.displayAlert(
                "PASSWORD ERROR",
                "Oops! Error in changing password. Please contact the Administrator or try again later",
                "danger"
              );
            }
          } else {
            PCtx.displayAlert(
              "PASSWORD ERROR",
              "The old password you entered is incorrect. Please try again. Note that passwords are case sensitive",
              "danger"
            );
          }
        }
      } else {
        PCtx.displayAlert(
          "PASSWORD ERROR",
          "The Username you entered is incorrect. Please try again. Note that passwords are case sensitive",
          "danger"
        );
      }
    } else {
      PCtx.displayAlert(
        "PASSWORD ERROR",
        "Your two new passwords did not match. Please try again. Note that passwords are case sensitive",
        "danger"
      ); //Passwords did not match
    }
  };

  return (
    <Row>
      <Col md={12} sm={12}>
        <Row>
          <Col md={12}>
            <Card style={{ height: "35px" }}>
              <Card.Body>
                <h4
                  className="text-center "
                  style={{ color: "brown", fontFamily: "Times New Roman" }}
                >
                  <Divider className="m-0">CHANGE PASSWORD</Divider>
                </h4>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row className="justify-content-around mt-2">
          <Col md={4}>
            <Card>
              <Card.Header>
                <h3>PASSWORD FORM</h3>
              </Card.Header>
              <Card.Body>
                <Form onSubmit={changeThePassword}>
                  <Row className="justify-content-around">
                    <Col md={8} sm={8} xs={8}>
                      <InputText
                        label="Username"
                        myName="Username"
                        myVal={Username}
                        myOnChange={setUsername}
                        Compulsory={true}
                        required={true}
                      />
                    </Col>
                    <Col md={8} sm={8} xs={8}>
                      <InputPassword
                        label=" Old Password"
                        myName="OldPassword"
                        myVal={OldGateway}
                        myOnChange={setOldGateway}
                        Compulsory={true}
                        required={true}
                      />
                    </Col>
                    <Col md={8} sm={8} xs={8}>
                      <InputPassword
                        label=" New Password"
                        myName="NewPassword"
                        myVal={NewGateway}
                        myOnChange={setNewGateway}
                        Compulsory={true}
                        required={true}
                      />
                    </Col>
                    <Col md={8} sm={8} xs={8}>
                      <InputPassword
                        label=" Retype New Password"
                        myName="RePassword"
                        myVal={ReNewGateway}
                        myOnChange={setReNewGateway}
                        Compulsory={true}
                        required={true}
                      />
                    </Col>
                    <Button variant="success" type="submit">
                      Change Password
                    </Button>
                  </Row>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default ChangePassword;
